export enum IAdvertisementRadioActionTypes {
  GET_AD_RADIO = '@@adRadio/GET_AD_RADIO',
  GET_AD_RADIO_SUCCESS = '@@adRadio/GET_AD_RADIO_SUCCESS',
  GET_AD_RADIO_FAILURE = '@@adRadio/GET_AD_RADIO_FAILURE',
}

export interface IAdvertisementRadio {
  result: AdvertisementRadioResult | null;
  isLoading: boolean;
  error: string;
}

export interface AdvertisementRadioResult {
  ad: AdRadio;
  group_ads: GroupAdRadio[];
  tracks: TrackRadio[];
}

export interface AdRadio {
  advertiser_code: number;
  advertiser_name?: string;
  created: string;
  creative_agency_code?: number;
  creative_agency_name?: string;
  duration: number;
  filmid_label: string;
  first_diffusion: string | null;
  first_diffusion_media?: {
    id: number;
    name: string;
  };
  group_id: number;
  id: number;
  internal_name?: string;
  product_code?: string;
  reference_ad_id: number;
  title: string;
  under_embargo: boolean;
}

export interface GroupAdRadio {
  arpp_code: string;
  filmid_label: string;
  id: number;
}

export interface TrackRadio {
  artist: any;
  authors: any;
  bed: boolean;
  bucket_name: any;
  composers: string;
  end_time: number;
  fgp_id: number;
  film_group_id: number;
  film_id: number;
  gain: number;
  isrc: any;
  iswc: any;
  master_filepath: any;
  music_state_id: string;
  offset_end: number;
  offset_start: number;
  source: string;
  start_time: number;
  title: string;
}
